export default __webpack_public_path__ + "static/media/our-service-information-technology-background.7b018c88.jpg";